import {
  CascadiaColor,
  CascadiaStandardIcon,
  CascadiaTypographyStyle,
} from "@certn/cascadia-tokens";
import { css, cx } from "@emotion/css";

import { Text } from "../../../foundations/typography/Text";
import { GhostIconButton } from "../../button/GhostIconButton";
export interface InnerContentItemProps {
  children?: React.ReactNode;
  label?: string;
  icon?: CascadiaStandardIcon;
  provided?: boolean;
  onIconPress?: () => void;
  testID?: string;
  textStyle?: CascadiaTypographyStyle;
  textColor?: CascadiaColor;
}

export function InnerContentItem({
  label,
  children,
  icon,
  provided = true,
  onIconPress: onIconClick,
  testID = "inner-content-item",
  textStyle = "summary/content-primary",
  textColor = "text-base",
}: InnerContentItemProps) {
  return (
    <div
      className={cx("InnerContentItem", css([styles.innerContentItem]))}
      data-testid={`${testID}-inner-content`}
    >
      <div className={css(styles.innerContentTextWrapper)}>
        <div>
          {label && (
            <Text
              as="div"
              style="summary/content-secondary"
              color="text-weak"
              testID={`${testID}-label`}
            >
              {label}
            </Text>
          )}
          <Text
            style={textStyle}
            color={provided ? textColor : "text-placeholder"}
            testID={`${testID}-content`}
          >
            {children}
          </Text>
        </div>
        {icon && (
          <GhostIconButton size="small" onPress={onIconClick} icon={icon} />
        )}
      </div>
    </div>
  );
}

const styles = {
  innerContentTextWrapper: css({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
  }),
  innerContentItem: css({
    marginTop: "var(--space-4)",
    marginBottom: "var(--space-4)",
    paddingRight: "var(--space-4)",
    paddingLeft: "var(--space-4)",
  }),
};
